import CreateDataRetrievalBegunAction from "./CreateDataRetrievalBegunAction";
import CreateDataRetrievalEndedAction from "./CreateDataRetrievalEndedAction";

import { GET } from "../adapters/xhr";

export default function () {
    return (dispatch) => {
        dispatch(CreateDataRetrievalBegunAction());

        const url = "api/EpirbReturnLinkServiceType/GetAllForDropdown";

        GET(url)
            .then(function (response) {
                if (response.status === 200) {
                    dispatch({
                        type: "EPIRB_RETURN_LINK_SERVICE_TYPES_RETRIEVED",
                        epirbLinkServiceFeatures: response.data
                    });
                }

                dispatch(CreateDataRetrievalEndedAction());
            }).catch(function (response) {
                dispatch(CreateDataRetrievalEndedAction());
            });
    }
}
